import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

const LinkTab = ({ playbookLink }) => {
  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(playbookLink)
      .then(() => {
        toast.success("Link copied to clipboard!");
      })
      .catch((err) => {
        toast.error("Failed to copy the link: ");
        console.error("error while copying link", err);
      });
  };

  return (
    <div className="side-panel-body">
      <div>
        <Form.Group className="mt-3">
          <Form.Label
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "20px",
            }}
          >
            Playbook Link
          </Form.Label>
         
          <div className="d-flex align-items-center justify-content-end flex-0-auto">
          <Form.Control
            type="text"
            value={playbookLink}
            readOnly
            onClick={(e) => e.target.select()}
            className="border-radius-right-0"
          />
            <Button
              variant="primary"
              onClick={() => handleCopyLink()}
              className="m-0 flex-0-auto create-button transition-transform duration-200 ease-in-out transform hover:bg-blue-600 active:bg-blue-700 hover:scale-105 active:scale-95 border-radius-left-0"
            >
              Copy Link
            </Button>
          </div>
        </Form.Group>
      </div>
    </div>
  );
};

export default LinkTab;
